import { render, staticRenderFns } from "./collect.vue?vue&type=template&id=2a13fbf6&scoped=true"
import script from "./collect.vue?vue&type=script&lang=js"
export * from "./collect.vue?vue&type=script&lang=js"
import style0 from "./collect.vue?vue&type=style&index=0&id=2a13fbf6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a13fbf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\mrzhj\\Desktop\\ff\\frontent\\takeout\\www\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a13fbf6')) {
      api.createRecord('2a13fbf6', component.options)
    } else {
      api.reload('2a13fbf6', component.options)
    }
    module.hot.accept("./collect.vue?vue&type=template&id=2a13fbf6&scoped=true", function () {
      api.rerender('2a13fbf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/user/collect.vue"
export default component.exports